export default __webpack_public_path__ + "static/media/round_table.43b0ffb1.webp";